export default __webpack_public_path__ + "static/media/Installment.c35ce1f7.svg";